export const LOCALES = {
  ENGLISH: 'en-us',
  JAPAN: 'ja',
};
